import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const TermsOfService = () => {
  const lastUpdated = "February 11, 2025";

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8">
          <Link to="/login">
            <Button variant="ghost" className="mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          <p className="text-gray-600 mt-2">Last updated: {lastUpdated}</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing and using the Athlete Attendance App Athlete Attendance Management system ("Service"), 
              you accept and agree to be bound by these Terms of Service ("Terms"). If you do not agree to 
              these Terms, you should not use this Service. These Terms apply to all users of the Service, 
              including administrators, coaches, and any other authorized personnel.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-700 leading-relaxed">
              The Service provides athlete attendance management tools for sports organizations, including 
              but not limited to: athlete roster management, program scheduling, attendance tracking, 
              and reporting functionality. The Service is provided by Anglin Sports Consultancy and is 
              intended for use by authorized sports coaching staff and administrators.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. User Accounts</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Access to the Service requires authorized credentials. You are responsible for:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Maintaining the confidentiality of your login credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use of your account</li>
              <li>Ensuring that your account information is accurate and up-to-date</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Acceptable Use</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Use the Service in any way that violates applicable laws or regulations</li>
              <li>Attempt to gain unauthorized access to any part of the Service</li>
              <li>Interfere with or disrupt the Service or servers connected to the Service</li>
              <li>Use the Service to transmit any malicious code or harmful content</li>
              <li>Share your account credentials with unauthorized third parties</li>
              <li>Use the Service for any purpose other than athlete attendance management</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Data and Privacy</h2>
            <p className="text-gray-700 leading-relaxed">
              Your use of the Service is also governed by our Privacy Policy. You acknowledge that you have 
              read and understood our Privacy Policy and consent to the collection and use of your information 
              as described therein. You are responsible for ensuring that any personal data you enter into 
              the Service is collected and processed in compliance with applicable data protection laws.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed">
              The Service and its original content, features, and functionality are owned by Anglin Sports 
              Consultancy and are protected by international copyright, trademark, and other intellectual 
              property laws. You may not copy, modify, distribute, sell, or lease any part of the Service 
              without explicit written permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Service Availability</h2>
            <p className="text-gray-700 leading-relaxed">
              We strive to maintain Service availability but do not guarantee uninterrupted access. 
              The Service may be temporarily unavailable due to maintenance, updates, or circumstances 
              beyond our control. We reserve the right to modify, suspend, or discontinue the Service 
              at any time with or without notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              To the maximum extent permitted by law, Anglin Sports Consultancy shall not be liable for 
              any indirect, incidental, special, consequential, or punitive damages, including but not 
              limited to loss of data, loss of profits, or business interruption, arising from your use 
              of or inability to use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Disclaimer of Warranties</h2>
            <p className="text-gray-700 leading-relaxed">
              The Service is provided "as is" and "as available" without warranties of any kind, either 
              express or implied, including but not limited to implied warranties of merchantability, 
              fitness for a particular purpose, and non-infringement. We do not warrant that the Service 
              will be error-free or that defects will be corrected.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Indemnification</h2>
            <p className="text-gray-700 leading-relaxed">
              You agree to indemnify, defend, and hold harmless Anglin Sports Consultancy, its officers, 
              directors, employees, and agents from any claims, damages, losses, liabilities, and expenses 
              (including legal fees) arising from your use of the Service or violation of these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to modify these Terms at any time. We will notify users of significant 
              changes by posting a notice on the Service or sending an email. Your continued use of the 
              Service after such modifications constitutes acceptance of the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">12. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms shall be governed by and construed in accordance with the laws of the Cayman Islands, 
              without regard to its conflict of law provisions. Any disputes arising from these Terms or the 
              Service shall be subject to the exclusive jurisdiction of the courts of the Cayman Islands.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">13. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <p className="text-gray-700 mt-2">
              <strong>Email:</strong>{' '}
              <a href="mailto:info@attendancetracker.ws" className="text-blue-600 hover:underline">
                info@attendancetracker.ws
              </a>
            </p>
          </section>
        </div>

        <div className="mt-8 text-center text-sm text-gray-600">
          © 2025 Anglin Sports Consultancy. Built for coaches.
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
